import { render, staticRenderFns } from "./GetStartedStep.vue?vue&type=template&id=682fe4e2"
import script from "./GetStartedStep.vue?vue&type=script&lang=ts"
export * from "./GetStartedStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports